import { getEnviormentUrls } from '../functions';

let instance = null;

class AppConfig {
    constructor() {
        if (!instance) {
            this.init();
            instance = this;
        }

        return instance;
    }

    init() {
        const { apiHost, mediaHost } = getEnviormentUrls();

        this.debug_mode = false;

        this.api = {
            https: true,
            baseUrl: apiHost,
            path: "website_api",
            platform: 'website',
            version: '1.0',
            requests: {
                getHostUrl: 'getHostUrl',
                generalDeclaration: 'generalDeclaration',
                getInsurancePage: 'getInsurancePage',
                createInsuranceLead: 'createInsuranceLead',
            },
        };

        this.full_path = (this.api.https ? 'https' : 'http') + '://' + apiHost;
        this.media_path = (this.api.https ? 'https' : 'http') + '://' + mediaHost;

        this.token = this.getToken();
    }

    // Token caching
    getToken = () => localStorage.getItem('token');
    setToken = (token) => localStorage.setItem('token', token);
}

export default AppConfig;
